import React, { useState } from 'react';
import '../css/Chatbot.css';
import { RiChat1Line } from "react-icons/ri";
const ChatBot = () => {
    const [isOpen, setIsOpen] = useState(false);

    const messages = [
        { sender: 'user', text: "What do I have to do today?" },
        { sender: 'ai', text: "You haven't gone for a swim in recent times. How about that?" },
        { sender: 'user', text: "Sounds good! What's the weather like?" },
        { sender: 'ai', text: "It’s sunny and perfect for a swim." },
        { sender: 'user', text: "Great, should I bring anything special?" },
        { sender: 'ai', text: "Make sure to bring sunscreen and a towel." },
        { sender: 'user', text: "Thanks! How long should I swim?" },
        { sender: 'ai', text: "I recommend at least 30 minutes for a good workout." }
    ];

    const toggleChat = () => setIsOpen(!isOpen);

    return (
        <div>
            <div className={`chatbot-container ${isOpen ? 'open' : ''}`}>
                {messages.map((msg, index) => (
                    <div key={index} className={`chat-message ${msg.sender === 'ai' ? '' : 'ai'}`}>
                        {msg.text}
                    </div>
                ))}
            </div>
            <div className="chatbot-icon" onClick={toggleChat}>
            <RiChat1Line />
            </div>
        </div>
    );
};

export default ChatBot;
